import { DateField, useRecordContext, useStore } from "react-admin";
import { getTimeDiffLabel, getValue, objectMap } from "../utils/tools";
import { Box } from "@mui/material";
import { Debug } from "./debug";
import { BrowserTimezone, TIMEZONE_KEY } from "./timezoneSelect";

const DateBox = ({ tz, label, ...props }) => {
  return (
    <Box className="DateBox">
      {label && <span>{label}: </span>}
      <DateField {...props} options={tz ? { timeZone: tz } : {}} />
    </Box>
  );
};

function containsTimezone(dateStr) {
  // Regex to match Z, +hh:mm, -hh:mm, +hhmm, -hhmm
  const tzRegex = /(Z|[+-]\d{2}:?\d{2})$/;
  return tzRegex.test(dateStr);
}

export const MyDateField = ({ timezones, fixNoTimezone = true, ...props }) => {
  const record = props.record || useRecordContext();
  const [timezone] = useStore(TIMEZONE_KEY, BrowserTimezone);
  const dateSource = props.source;
  let date = getValue(record, dateSource);
  timezones = timezones || { "": timezone };

  if (!date) return null;

  if (fixNoTimezone && date && !containsTimezone(date)) {
    console.warn(`Date with no timezone, assume UTC: ${date}`);
    date += "+00:00";
    record[props.source] = date;
  }

  let your_time_shown = false;
  const dates = Object.values(
    objectMap({
      obj: timezones,
      valueCallback: (tz, label) => {
        if (!tz || tz === BrowserTimezone) {
          your_time_shown = true;
        }
        return <DateBox {...props} key={tz} tz={tz} label={label} />;
      },
    })
  );

  !your_time_shown &&
    dates.push(
      <Debug key={"debug"}>
        <DateBox {...props} tz={undefined} label={"YT"} />
      </Debug>
    );

  return (
    <Box className="MyDateField" title={date}>
      {dates}
      <Box className="MyDateFieldHuman">({getTimeDiffLabel(null, date)})</Box>
    </Box>
  );
};
